import {
  usePostHogFeatureFlag,
  POSTHOG_FEATURE_FLAGS
} from '@percent/admin-dashboard/common/hooks/usePostHogFeatureFlag'
import { usePermissions } from '@percent/admin-dashboard/common/hooks/usePermissions'

type GrantsPermission = `can_${string}`

export function useGrantsPermissions<T extends GrantsPermission[]>(permissions: [...T]): { [K in keyof T]: boolean } {
  const internalFgaGrantsFeatureFlag = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.INTERNAL_FGA_GRANTS)
  const { userHasPermissions } = usePermissions()

  return permissions.map(p => !internalFgaGrantsFeatureFlag || userHasPermissions(`grants:${p}`)) as {
    [K in keyof T]: boolean
  }
}
